export default {"src":"/_next/static/media/datasheet.43e6d203.svg","height":30,"width":24,"blurWidth":0,"blurHeight":0};